import { render, staticRenderFns } from "./UploadAtestado.vue?vue&type=template&id=3c9a0e5c&scoped=true&"
import script from "./UploadAtestado.vue?vue&type=script&lang=js&"
export * from "./UploadAtestado.vue?vue&type=script&lang=js&"
import style0 from "./UploadAtestado.vue?vue&type=style&index=0&id=3c9a0e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9a0e5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAlert,VImg})
